import React from "react";

export default function OurServices() {
  return (
    <div>
      <div class="our_services_wrapper float_left">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper heading_wrapper_dark dark_heading">
                <h4> services</h4>
                <h3>our features</h3>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-sm-6 col-12">
              <div class="investment_box_wrapper service_box feature_box float_left">
                <div class="investment_icon_circle">
                  <i class="flaticon-medal"></i>
                </div>
                <div class="investment_border_wrapper"></div>
                <div class="investment_content_wrapper">
                  <h1>
                    <a href="#">We're Certified</a>
                  </h1>
                  <p>
                    We are a legal company registered in the , providing its
                    investment services to the members all around the world
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-sm-6 col-12">
              <div class="investment_box_wrapper service_box feature_box float_left">
                <div class="investment_icon_circle red_info_circle">
                  <i class="flaticon-shield"></i>
                </div>
                <div class="investment_border_wrapper red_border_wrapper"></div>
                <div class="investment_content_wrapper red_content_wrapper">
                  <h1>
                    <a href="#">We're Secure</a>
                  </h1>
                  <p>
                    Our website is using Comodo SSL encryption and that confirms
                    that the presented content is the genuine and legitimate
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-sm-6 col-12">
              <div class="investment_box_wrapper service_box feature_box float_left">
                <div class="investment_icon_circle blue_icon_circle">
                  <i class="flaticon-bars"></i>
                </div>
                <div class="investment_border_wrapper blue_border_wrapper"></div>
                <div class="investment_content_wrapper blue_content_wrapper">
                  <h1>
                    <a href="#">We're Profitable</a>
                  </h1>
                  <p>
                    We are team of professional traders in Forex & Crypto
                    Exchange and Coins trading and Crypto Mining who know how to
                    grab the profit end of the day
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-sm-6 col-12">
              <div class="investment_box_wrapper service_box feature_box float_left">
                <div class="investment_icon_circle">
                  <i class="flaticon-language"></i>
                </div>
                <div class="investment_border_wrapper yellow_border_wrapper"></div>
                <div class="investment_content_wrapper yellow_content_wrapper">
                  <h1>
                    <a href="#">We're global</a>
                  </h1>
                  <p>
                    We accept clients from all the part of the world and also
                    support multiple means to withdraw and deposit, this is why
                    we are unique
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 col-sm-6 col-12">
              <div class="investment_box_wrapper service_box feature_box float_left">
                <div class="investment_icon_circle green_info_circle">
                  <i class="flaticon-bitcoin"></i>
                </div>
                <div class="investment_border_wrapper green_border_wrapper"></div>
                <div class="investment_content_wrapper green_content_wrapper">
                  <h1>
                    <a href="#">We Accept Crypto</a>
                  </h1>
                  <p>
                    Our company accepts cryptocurrency such as Bitcoin,
                    Litecoin, Ethereum, and other cryptocurrencies as a means of
                    payment method, clients must be very careful when providing
                    or copying our wallet address
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-sm-6 col-12">
              <div class="investment_box_wrapper service_box feature_box float_left">
                <div class="investment_icon_circle pink_info_circle">
                  <i class="flaticon-headphones"></i>
                </div>
                <div class="investment_border_wrapper pink_border_wrapper"></div>
                <div class="investment_content_wrapper pink_content_wrapper">
                  <h1>
                    <a href="#">best support</a>
                  </h1>
                  <p>
                    We understand how important having reliable support service
                    is to you. Please don't hesitate to contact us should you
                    have any questions and we will get back to you in 24 Hours!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
